import { Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import LocalPlayIcon from '@mui/icons-material/LocalPlay'
import { useState } from 'react'
import { Link } from 'settle-ui/components/Link/Link'
import { ViewPromoCodeDialog } from 'routes/dialogs/ViewPromoCodeDialog/ViewPromoCodeDialog'
import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'
import { withPromoAppliedSubscription } from './hocs/withPromoAppliedSubscription'
import type { PromoCodeMessageProps } from './PromoCodeMessage.types'

export const PromoCodeMessage: Settle.FC<PromoCodeMessageProps> = ({ sx, type, ...props }) => {
  const [viewPromoCodeDialogOpen, setViewPromoCodeDialogOpen] = useState(false)
  const { promoCode } = useAppliedPromoCodeContext()

  const message =
    type === 'inApp' ? (
      <Trans
        i18nKey="promoCodeApplicationMessage::inApp"
        components={{
          details: <Link fontSize="inherit" onClick={() => setViewPromoCodeDialogOpen(true)} />,
        }}
        values={{ name: promoCode?.displayName }}
      />
    ) : (
      <Trans i18nKey="promoCodeApplicationMessage::onboarding" values={{ name: promoCode?.displayName }} />
    )

  return (
    <>
      <Stack
        data-testid="promo-code-message"
        {...props}
        sx={{
          borderRadius: '5px',
          flexDirection: 'row',
          alignItems: 'center',
          gap: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(1, 1.5, 1, 1),
          backgroundColor: (theme) => theme.tokens.ThemeColorCommonPrimaryContainer,
          ...sx,
        }}
      >
        <LocalPlayIcon color="secondary" />
        <Typography variant="body2">{message}</Typography>
      </Stack>
      <ViewPromoCodeDialog open={viewPromoCodeDialogOpen} onClose={() => setViewPromoCodeDialogOpen(false)} />
    </>
  )
}

export const PromoCodeMessageSubscribed = withPromoAppliedSubscription(PromoCodeMessage)
